module.exports = __webpack_public_path__ + "media/images/icons/edit-8b62498a2fbdbc24996139f57ab7d8c6.svg";